import { createBlock as e, createCommentVNode as t, createElementBlock as n, defineComponent as r, normalizeStyle as i, onBeforeUnmount as a, openBlock as o, renderSlot as s, resolveDynamicComponent as c, withCtx as l, withModifiers as u } from "vue";
//#region src/schema/SchemaRailPanel.vue?vue&type=script&setup=true&lang.ts
var d = /*@__PURE__*/ r({
	__name: "SchemaRailPanel",
	props: {
		depth: {},
		closeOnRail: {
			type: Boolean,
			default: !1
		},
		as: { default: "div" }
	},
	emits: ["close"],
	setup(r, { emit: d }) {
		let f = d, p = null, m = () => {
			p?.panel.removeAttribute("data-rail-hovered"), p?.row?.removeAttribute("data-child-rail-hovered"), p = null;
		}, h = (e, t) => {
			if (m(), !t) return;
			let n = e.currentTarget instanceof HTMLElement ? e.currentTarget.parentElement : null;
			if (!n) return;
			let r = n.parentElement;
			n.setAttribute("data-rail-hovered", ""), r?.setAttribute("data-child-rail-hovered", ""), p = {
				panel: n,
				row: r
			};
		}, g = () => {
			m(), f("close");
		};
		return a(m), (a, d) => (o(), e(c(r.as), {
			class: "schema-rail-panel schema-rail rail-hover:border-s-c-1 relative ps-[var(--schema-gutter,16px)]",
			style: i({ "--schema-depth": r.depth })
		}, {
			default: l(() => [r.closeOnRail ? (o(), n("div", {
				key: 0,
				"aria-hidden": "true",
				class: "rail-hit z-[1]",
				"data-rail-hit": "",
				onClick: u(g, ["stop"]),
				onPointerenter: d[0] ||= (e) => h(e, !0),
				onPointerleave: d[1] ||= (e) => h(e, !1)
			}, null, 32)) : t("", !0), s(a.$slots, "default")]),
			_: 3
		}, 8, ["style"]));
	}
});
//#endregion
export { d as default };

//# sourceMappingURL=SchemaRailPanel.vue.script.js.map